module.exports = __webpack_public_path__ + "img/bg_contacts.bfd88fdc.png";